"use client";

import React from 'react';
import MainLayout from '@/layouts/MainLayout';
import Pricing from '@/components/Pricing';
import TestimonialWall from '@/components/TestimonialWall';

const Home: React.FC = () => {
  return (
    <MainLayout>
      <div id="pricing" className="pt-16">
        <h2 className="text-4xl md:text-5xl font-semibold text-foreground text-center mb-4 md:mb-16">Unlock the growth you deserve</h2>
        <Pricing />
      </div>
      <div id="testimonials" className="">
        <TestimonialWall />
      </div>
    </MainLayout>
  );
}

export default Home;
